<template>
    <div class="boxs flexCentet">
        <img src="../../../assets/images/newicon/title-left.png" alt="" />
        <p>{{ title }}</p>
        <img src="../../../assets/images/newicon/title-right.png" alt="" />
    </div>
  </template>
  
  <script>
  export default {
    props: {
      title:{
        type:String,
        dafault:null
      }
    },
    data() {
      return {
        
      };
    },
  };
  </script>
  
  <style lang="scss" scoped>
    $whiteColor:#fff;
    $fontCol:rgba(0,0,0,0.85);
    $secondfontCol:rgba(0,0,0,0.5);
    $yellowColor:#FF8A16;
    $mianColor:#287CF3;
    .boxs{
        margin: 30px auto;
        img{
            width: 176px;
        }
        p{
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: $fontCol;
            padding: 0 20px;
        }
    }
  </style>
  